import React from 'react'

const Label = ({ required, classLabel, label }) => {
  return (
    <>
      {
        required ?
          <>
            <label className={classLabel}><span className="required">* </span>{label}</label>
          </>
          :
          <label className={classLabel}>{label}</label>
      }
    </>
  )
}

export default Label